import React from 'react';
import KickImage from 'Reuseables/KickImage';
import ButtonCard from '../../Atoms/ButtonCard';

import { IRecentSearchProps } from './RecentSearch.definitions';

/** CSS import */
import Styles from './RecentSearch.module.scss';
import useFetchRecentSearch from 'Pages/Blog/Hooks/useFetchRecentSearch';

const ITEMS = [
  'Nike',
  'Adidas',
  'Jordan',
  'Yeezy',
  'Off-White',
  'Supreme',
  'Balenciaga',
];

const RecentSearch: React.FC<IRecentSearchProps> = ({}: IRecentSearchProps) => {
  const { fetchRecentSearch, data, isFetching } = useFetchRecentSearch();

  React.useEffect(() => {
    fetchRecentSearch();
  }, []);

  if (!data || (data.length === 0 && !isFetching))
    return <div className={Styles['wrapper']} />;

  return (
    <div className={Styles['wrapper']}>
      <span className={Styles['recent-search-title']}>Recent Search</span>
      <div className={Styles['item-container']}>
        {data.map((t) => (
          <ButtonCard
            text={t.query}
            withX
            className={Styles['recent-search-item']}
            onClick={() => {}}
            onClickX={() => {}}
          />
        ))}
      </div>
    </div>
  );
};

export default RecentSearch;
